import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.013 9c-.287 0-.561-.105-.764-.292L.93 4.716a1 1 0 0 1-.242-.324.93.93 0 0 1-.007-.772 1 1 0 0 1 .236-.328 1.1 1.1 0 0 1 .355-.218 1.16 1.16 0 0 1 .835.007q.199.079.35.224L6.013 6.59l3.556-3.286c.204-.182.477-.283.76-.28s.554.107.754.292.314.435.317.697a.96.96 0 0 1-.304.702l-4.32 3.992A1.13 1.13 0 0 1 6.013 9"
    }, null, -1)
  ])))
}
export default { render: render }